import React, { useState, useContext, useEffect } from 'react';
import {
  Box, Button, Paper, Divider, Typography, Dialog,
  DialogActions, DialogContent, DialogTitle, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useParams } from 'react-router-dom';

import ProjectHeader from '../components/project/ProjectHeader';
import FileThumbnail from '../components/commonComponents/FileThumbnail';
import SubmitWork from '../components/project/SubmitWork';
import OtherTeamSubmissions from '../components/project/OtherTeamSubmissions';
import CollapsibleTable from '../components/CollapsibleTable';
import Loading from '../components/commonComponents/Loading';

import { AuthContext } from '../components/Auth/Auth';
import {
  fetchClubProjectById,
  fetchEnrollments,
  fetchClubById,
  getAllMembersOfClub,
  fetchSubmissionByUser,
  getUserMembershipStatus,
  getTeamMembersData,
  updateTeamInFirestore,
  checkIfUserIsAdminForClub
} from '../components/Helper';

export default function Project() {
  const { clubId, projectId } = useParams();
  const { currentUser } = useContext(AuthContext);

  const [openDialog, setOpenDialog] = useState(false);
  const [userTeam, setUserTeam] = useState(null);
    const [clubData, setClubData] = useState(null);
  
  const [project, setProject] = useState();
  const [isClubMember, setIsClubMember] = useState(false);
  const [loading, setLoading] = useState(true);
  const [enrollments, setEnrollments] = useState([]);
  const [currentEnrollments, setCurrentEnrollments] = useState([]);
  const [submission, setSubmission] = useState(null);

  const [isCurrentUserAdmin, setIsCurrentUserAdmin] = useState(false);

    useEffect(() => {
      async function fetchData() {
        const clubs = await fetchClubById(clubId);
        setClubData(clubs);
      }
    fetchData();
    }, [ clubId]);
  
    useEffect(() => {
      const fetchAdminStatus = async () => {
        try {
          const isAdmin = await checkIfUserIsAdminForClub(clubId, currentUser.uid);
          setIsCurrentUserAdmin(isAdmin);
        } catch (error) {
          console.error("Error checking admin status:", error);
          setIsCurrentUserAdmin(false);
        }
      };
  
      if (clubId && currentUser?.uid) {
        fetchAdminStatus();
      }
    }, [clubId, currentUser.uid]);



  console.log("all members of club", getAllMembersOfClub(clubId));

  // Fetch all members of the club
  const fetchAllMembers = async () => {
    try {
      const members = await getAllMembersOfClub(clubId);
      return members;
    } catch (error) {
      console.error("Error fetching club members:", error);
      return [];
    }
  }
  useEffect(() => {
    fetchAllMembers().then(members => {
      console.log("Fetched club members:", members);
    });
  }, [clubId]);



  useEffect(() => {
    fetchData();
  }, [currentUser?.uid, clubId]);

  async function fetchData() {
    setLoading(true);
    try {
      const enrollmentsList = await fetchEnrollments();
      setEnrollments(enrollmentsList);

      const projectData = await fetchClubProjectById(projectId);
      setProject(projectData);
      console.log("Project data:", projectData);
      console.log("Project data:", projectData?.title);
      console.log("Project data::", clubData?.name);
      const enrollment = enrollmentsList.find(e => e.projectId === projectId && e.clubId === clubId);

      if (enrollment) {
        const updatedTeams = await Promise.all(
          enrollment.teams.map(async (team) => {
            const membersData = await getTeamMembersData(team.members);
            return { ...team, members: membersData };
          })
        );

        setCurrentEnrollments({ ...enrollment, teams: updatedTeams });

        const userTeamData = updatedTeams.find(team =>
          team.members.some(member => member.uid === currentUser?.uid)
        );
        console.log("User team data:", userTeamData);

        setUserTeam(userTeamData ?? undefined);

        const isMember = await getUserMembershipStatus(currentUser.uid, clubId);
        setIsClubMember(isMember);

        if (userTeamData?.name && isMember) {
          const submissionData = await fetchSubmissionByUser(
            clubId,
            projectId,
            userTeamData.name,
            currentUser?.uid
          );
          setSubmission(submissionData?.submissionData);
        }
      } else {
        setUserTeam(undefined);
      }
    } catch (err) {
      console.error('Error fetching project data:', err);
    }
    setLoading(false);
  }

  const handleEnrollment = async (teamData) => {
    await updateTeamInFirestore(clubId, projectId, teamData, currentUser.uid);
    fetchData();
  };

  const getExistingTeamNames = () => {
    const docName = `${clubId}_${projectId}`;
    const currentDocObj = enrollments.find(e => e.uid === docName);
    return currentDocObj?.teams.map(team => team.name) ?? [];
  };

  const MemberListDialog = ({ open, handleClose, teams }) => (
    <Dialog onClose={handleClose} open={open} maxWidth='md' fullWidth>
      <DialogTitle>Team members</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{ position: 'absolute', right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <CollapsibleTable teamMembers={teams} />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button variant='outlined' onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );

  if (loading) return <Loading />;

  return (
    <Box sx={{ py: 6, px: { xs: 2, md: 12, lg: 18, xl: 32 } }}>
      <Paper sx={{ p: 6, pt: 3 }}>

        <Typography variant="h4" fontWeight="bold" textAlign="center" mb={4}>
          {clubData?.name}
        </Typography>

        <ProjectHeader
          isCurrentUserAdmin={isCurrentUserAdmin}
          projectData={project}
          userTeamName={userTeam?.name}
          handleEnrollment={handleEnrollment}
          isClubMember={isClubMember}
          getExistingTeamNames={getExistingTeamNames}
          loading={loading}
        />
        

        

        {/* Button to open team members dialog
        <Box mt={2} mb={3}>
          <Button variant="outlined" onClick={() => setOpenDialog(true)}>
            View All Team Members
          </Button>
        </Box> */}

        {/* Dialog for viewing all team members */}

        <MemberListDialog
          open={openDialog}
          handleClose={() => setOpenDialog(false)}
          teams={currentEnrollments?.teams ?? []}
        />

        <OtherTeamSubmissions teams={currentEnrollments?.teams ?? []} clubId={clubId} projectId={projectId} isCurrentUserAdmin={isCurrentUserAdmin} />


        <Divider />
        <Typography mt={2} variant='h6' fontWeight={600}>Project Background</Typography>
        <Box my={2}>
          {project?.video_link && (
            <iframe width="500" height="340" src={project?.video_link} title="Project Video" />
          )}
        </Box>
        <div dangerouslySetInnerHTML={{ __html: project?.project_background ?? '' }} />

        <Typography variant='h6' gutterBottom fontWeight={600}>Your Task</Typography>
        <div dangerouslySetInnerHTML={{ __html: project?.task_description ?? '' }} />

        <Typography variant='h6' gutterBottom my={2} fontWeight={600}>Resources</Typography>
        <Box mb={6}>
          <FileThumbnail
            file={project?.resource}
            id={1}
            buttonId={2}
            loading={false}
            S3Download={() => { }}
          />
        </Box>

        
        {isClubMember == true ? (
          <SubmitWork
            mb={6}
            clubId={clubId}
            projectId={projectId}
            projectName={project?.title}
            clubName={clubData?.name}
            team={userTeam}
            user={currentUser?.uid ?? ''}
            submission={submission}
            fetchData={fetchData}
          />
        ) : null}
        

      </Paper>
    </Box>
  );
}
